import axios from 'axios';
import { loginreq, req } from './axiosFun';
import { getHttpParams } from '../utils/util';

// 充值管理
export const getCards = (params) => { return req("get", "/admin/cards?"+getHttpParams(params)) };
//新增
export const addCards = (params) => { return req("get", "/admin/cards/create?"+getHttpParams(params)) };

export const updateCards = (id, params) => { return req("patch", "/admin/cards/"+id+'?'+getHttpParams(params)) };

export const deleteCards = (id) => { return req("delete", "/admin/cards/"+id) };



// WEBPACK FOOTER //
// ./src/api/cards.js